// extracted by mini-css-extract-plugin
export default {"form":"styles_form__9NNB+","input":"styles_input__gTaGx"};